export enum RouteArea {
    US47CA = 0,
    Other = 1
}

export const RouteAreaMetadata = {
    '0': {
        display: 'US 47 + Canada',
        value: 0
    },
    '1': {
        display: 'Other',
        value: 1
    }
};
